export default __webpack_public_path__ + "static/media/anm-logo.3330448b.png";